import styled from 'styled-components';
import ListPageHeader from '~src/shared/headers/listPageHeader/ListPageHeader';

export const PerformanceManagerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
`;

export const StyledListPageHeader = styled(ListPageHeader)`
  position: unset;
  width: unset;
`;
